import { FunctionComponent } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useTranslation } from '@/lib';
import { TransactionStatus } from '../../api/transactions/transaction.contracts';
import { getTransactionStatusStyle } from '../../types/TransactionModel';

interface TransactionStatusFieldProps {
  value: TransactionStatus;
  onChange: (value: TransactionStatus) => void;
  disabled?: boolean;
  excludeFinalized?: boolean;
}

export const TransactionStatusField: FunctionComponent<TransactionStatusFieldProps> = ({ value, onChange, disabled = false, excludeFinalized = false }) => {
  const { t } = useTranslation();

  const getStatusLabel = (status: TransactionStatus) => {
    switch (status) {
      case TransactionStatus.InProgress:
        return t('in_progress');
      case TransactionStatus.Finalized:
        return t('finalized');
      default:
        return t('unknown');
    }
  };

  const availableStatuses = excludeFinalized 
    ? Object.values(TransactionStatus).filter(status => status !== TransactionStatus.Finalized)
    : Object.values(TransactionStatus);

  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel id="transaction-status-label">{t('status')}</InputLabel>
      <Select
        labelId="transaction-status-label"
        value={value}
        label={t('status')}
        onChange={(e) => onChange(e.target.value as TransactionStatus)}
      >
        {availableStatuses.map((status) => {
          const colors = getTransactionStatusStyle(status);
          return (
            <MenuItem key={status} value={status}>
              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-md font-medium ${colors.bg} ${colors.text}`}>
                {getStatusLabel(status)}
              </span>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
